
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'
import { getTokenSimuSaga } from './saga'
import { useLocation } from 'react-router-dom'
import injectSaga from '../../utils/injectSaga'
import { getTokenSimu, hideModal } from '../App/actions'
import '../../fonts/fonts.css'
import SideBar from '../SideBar/index'
import PageHeader from '../../components/PageHeader'
import AddStudent from '../../images/AddStudent.svg'
import ModalConfirm from '../../components/ModalConfirm/index'
import {
  Bg, MainLayout, Container,
  FormCard, TwoCol, FieldGroup, FieldLabel,
  Input, FeedBack, Divider, SectionTitle,
  SelectorLicenceContainer, LicenceSelector,
  TrainingChoices, CheckboxChip,
  CreateBtn, SuccessToast,
} from './styledComponents'

const editorPath = process.env.REACT_APP_SERVER_API
const whatApiToken = process.env.REACT_APP_WHATAPI_TOKEN

const PlayerCreate = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const agencyToken = useSelector((state) => state.toJS().global.agencytoken)
  const error = useSelector((state) => state.toJS().global.error)
  const successStore = useSelector((state) => state.toJS().global.success)
  const players = useSelector((state) => state.toJS().global.simuPlayers)
  const trainings =  useSelector((state) => state.toJS().global.trainings)
  const agencyTrainings = useSelector((state) => state.toJS().global.agencyTrainings)
  const agencyTrainingIds = useSelector((state) => state.toJS().global.agencyTrainingIds)
  const [trainingsCatalog, setTrainingsCatalog] = useState([])

  const id = location.query ? location.query.id : location.pathname.split('/')[3]
  const player = players ? players.find(player => player.id === id || player._id === id) : ''
  const [lastName, setLastName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [repPassword, setRepPassword] = useState('')
  const [wrongRepeat, setWrongRepeat] = useState()
  const [show, setShow] = useState(false)
  const [modalText, setModalText] = useState(false)
  const [verif, setVerif] = useState(false)
  const [warn, setWarn] = useState({ mail: false, psw: false, fName: false, error: false })
  const [borderColor, setBorderColor] = useState({ mail: '', psw: '' })
  const [success, setSuccess] = useState(false)
  const [playerLicence, setPlayerLicence] = useState('')
  const [playerTrainings, setPlayerTrainings] = useState(player?.availableTrainings || ['EVAL', 'REMC']);
  const [availableTrainings, setAvailableTrainings] = useState([]);
  console.log(agencyTrainings)
  console.log(playerTrainings)

  const workshopTitles = ['EVAL', 'REMC']
  const hasTrainingAccess = () => (
    (Array.isArray(agencyTrainings) && agencyTrainings.length > 0) ||
    (Array.isArray(agencyTrainingIds) && agencyTrainingIds.length > 0)
  )

  useEffect(() => {
    fetch(`${editorPath}/api/trainings?access_token=${whatApiToken}`)
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setTrainingsCatalog(data) })
      .catch(() => {})
  }, [])

  useEffect(() => {
    displayModal(successStore)
    errorCheck(error)
    verification()
    if (hasTrainingAccess()) {
      setAvailableTrainings([
        ...getTrainingTitles(true),
        ...getTrainingTitles(false)
      ])
    }
    // eslint-disable-next-line
  }, [error, successStore, playerLicence])

  const displayModal = (show) => {
    if(show){
      setSuccess(true)
      setTimeout(() => {
        dispatch(hideModal())
        setSuccess(false)
        setVerif(false)
      }, 2000);
    }
  }

  const errorCheck = (err) => {
    if (err) {
      if (err !== undefined && err.response !== undefined) {
        switch (err.response.status) {
          case 401:
            setShow(true); setSuccess(false); setWarn({ err: true }); setModalText('Vous n\'êtes pas identifié, veuillez vous déconnecter puis vous reconnecter')
            break
          case 409:
            setShow(true); setSuccess(false); setWarn({ err: true }); setModalText(`L'élève existe déjà.`)
            break
          default:
            setShow(true); setSuccess(false); setWarn({ fName: true }); setModalText('Erreur système')
            break
        }
      } else {
        setShow(true); setSuccess(false); setWarn({ err: true }); setModalText('Impossible d\'accéder au serveur')
      }
    }
  }

  const licences = [
    {value: 'B', label: 'B'},
    {value: 'BEA', label: 'BEA'},
    {value: 'AAC', label: 'AAC'},
    {value: 'BEA AAC', label: 'BEA AAC'}
  ]

  const DisplayLicenceSelector = () => (
    <LicenceSelector
      classNamePrefix='react-select'
      multiple={false}
      isSearchable={false}
      value={playerLicence ? licences.value : null}
      placeholder={'Sélectionnez un permis …'}
      onChange={(e) => { setPlayerLicence(e.value); verification() }}
      options={licences}
    />
  )

  const Checkbox = ({ name, boxChecked, onChange }) => (
    <CheckboxChip $checked={boxChecked ? 1 : 0} onClick={onChange}>
      {boxChecked && <span style={{ fontSize: '0.65rem' }}>✓</span>}
      {name}
    </CheckboxChip>
  )

  const getLegacyTrainingTitles = (isWorkshop) => {
    if (!agencyTrainings) return []
    if (typeof agencyTrainings[0] === 'string') {
      return agencyTrainings.filter(t => isWorkshop ? workshopTitles.includes(t) : !workshopTitles.includes(t))
    }
    return agencyTrainings.filter(t => isWorkshop ? t.isWorkshop : !t.isWorkshop).flatMap(t => t.title)
  }

  const getTrainingTitles = (isWorkshop) => {
    const titles = new Set(getLegacyTrainingTitles(isWorkshop))
    if (Array.isArray(agencyTrainingIds) && agencyTrainingIds.length > 0) {
      const allowedIds = new Set(agencyTrainingIds.map(String))
      trainingsCatalog
        .filter(t => allowedIds.has(String(t.id)) && Boolean(t.isWorkshop) === isWorkshop)
        .forEach(t => titles.add(t.title))
    }
    return Array.from(titles)
  }

  const displayTrainingsChoices = () => {
    if (hasTrainingAccess()) {
      return (
        <TrainingChoices>
          {getTrainingTitles(true).map((title, index) => (
            <Checkbox
              key={index}
              name={title}
              boxChecked={playerTrainings.includes(title)}
              onChange={() => handleTrainingClick(title)}
            />
          ))}
        </TrainingChoices>
      )
    }
    return <TrainingChoices />
  }

  const displayTrainingsChoices2 = () => {
    if (hasTrainingAccess()) {
      return (
        <TrainingChoices>
          {getTrainingTitles(false).map((title, index) => (
            <Checkbox
              key={index}
              name={title}
              boxChecked={playerTrainings.includes(title)}
              onChange={() => handleTrainingClick(title)}
            />
          ))}
        </TrainingChoices>
      )
    }
    return <TrainingChoices />
  }

  const handleTrainingClick = (trainingTitle) => {
    setPlayerTrainings(prevTrainings => {
      if (prevTrainings.includes(trainingTitle)) {
        return prevTrainings.filter(t => t !== trainingTitle)
      } else {
        return [...prevTrainings, trainingTitle]
      }
    })
  }

  function verification () {
    if (lastName && firstName && email && password && repPassword && playerLicence && playerTrainings && hasTrainingAccess() && (password === repPassword)) {
      if (!emailCheck()) {
        setVerif(true)
      }
    } else {
      setVerif(false)
    }
  }

  const handleChangeMail = useCallback ((event) => {
    const mail = event.target.value
    setEmail(mail)
  }, [])

  const emailCheck = () => {
    if (!email) {
      setBorderColor('#B3ABBC')
      setWarn({ mail: false })
      return
    }
    const expReg = /\S+@\S+\.\S+/
    const result = email.match(expReg)
    if (result == null && email) {
      setBorderColor('#FF0000')
      setWarn({ mail: true })
      return true
    } else {
      setBorderColor('#B3ABBC')
      setWarn({ mail: false })
      return false
    }
  }

  const handleChangePassword = useCallback ((event) => {
    const pass = event.target.value
    setPassword(pass)
  }, [])

  const handleChangeRepPassword = useCallback ((event) => {
    const repPass = event.target.value
    setRepPassword(repPass)
  }, [])

  const checkPassword = () => {
    if (repPassword && password && (repPassword !== password)) {
      setWrongRepeat(true)
    } else {
      setWrongRepeat(false)
    }
  }

  const clickHandlerAccount = () => {
    if (!verif) { return }
    dispatch(getTokenSimu({
      email: email,
      password: password,
      foreignKey: email,
      firstname: firstName,
      lastname: lastName,
      status: 1,
      trainingType: playerLicence,
      trainings: playerTrainings,
      availableTrainings: playerTrainings,
      access: 'premium',
      token: agencyToken}))
    reset()
  }

  const reset = () => {
    setVerif(true)
    setFirstName('')
    setLastName('')
    setEmail('')
    setPassword('')
    setRepPassword('')
    setPlayerLicence('')
  }

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      clickHandlerAccount()
    }
  }

  return (
    <Bg>
      <SideBar />
      <ModalConfirm
        show={show}
        text={'Attention'.toUpperCase()}
        confirm={() => setShow(false)}
        name={modalText}
        confirmText='OK'
        noCancel
      />
      <MainLayout>
        {success && <SuccessToast>✓ L'élève a bien été créé !</SuccessToast>}
        <PageHeader icon={AddStudent} title='Créer un élève' subtitle='Ajoutez un nouvel élève à votre auto-école' />

        <Container>
          <FormCard>

            {/* ── Identité ── */}
            <div>
              <SectionTitle>Identité</SectionTitle>
              <TwoCol>
                <FieldGroup>
                  <FieldLabel>Nom</FieldLabel>
                  <Input
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    onKeyPress={() => onKeyPress}
                    onKeyUp={() => verification()}
                  />
                </FieldGroup>
                <FieldGroup>
                  <FieldLabel>Prénom</FieldLabel>
                  <Input
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    onKeyPress={(e) => onKeyPress(e)}
                    onKeyUp={() => verification()}
                  />
                </FieldGroup>
              </TwoCol>
              <FieldGroup style={{ marginTop: '1rem' }}>
                <FieldLabel>Email</FieldLabel>
                <Input
                  value={email}
                  style={{ borderColor: borderColor }}
                  onChange={(e) => handleChangeMail(e)}
                  onKeyPress={(e) => onKeyPress(e)}
                  onKeyUp={() => { verification(); emailCheck() }}
                />
                {warn.mail && <FeedBack>Email non valide</FeedBack>}
              </FieldGroup>
            </div>

            <Divider />

            {/* ── Accès ── */}
            <div>
              <SectionTitle>Accès</SectionTitle>
              <FieldGroup>
                <FieldLabel>Mot de passe</FieldLabel>
                <Input
                  value={password}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onChange={(e) => handleChangePassword(e)}
                  onKeyPress={(e) => onKeyPress(e)}
                  onKeyUp={() => { checkPassword(); verification() }}
                />
              </FieldGroup>
              <FieldGroup style={{ marginTop: '1rem' }}>
                <FieldLabel>Répéter le mot de passe</FieldLabel>
                <Input
                  value={repPassword}
                  type='text'
                  style={{ borderColor: wrongRepeat ? '#EF4444' : '' }}
                  onChange={(e) => handleChangeRepPassword(e)}
                  onKeyPress={(e) => onKeyPress(e)}
                  onKeyUp={() => { checkPassword(); verification() }}
                />
                {wrongRepeat && <FeedBack>Les mots de passe ne correspondent pas</FeedBack>}
              </FieldGroup>
            </div>

            <Divider />

            {/* ── Permis ── */}
            <div>
              <SectionTitle>Permis</SectionTitle>
              <SelectorLicenceContainer>
                {DisplayLicenceSelector()}
              </SelectorLicenceContainer>
            </div>

            <CreateBtn disabled={!verif} onClick={() => clickHandlerAccount()}>
              Créer l'élève
            </CreateBtn>

          </FormCard>
        </Container>
      </MainLayout>
    </Bg>
  )
}

const withSaga = injectSaga({ key: 'SimuPlayerCreate', saga: getTokenSimuSaga })
const arg = compose(withSaga)(PlayerCreate)

export default arg
